<div class="col-xl-4 col-lg-6 col-md-6 grid-item case4">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/web-design/cmcapital.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case4">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/web-design/gbamsvidushi.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>

<div class="col-xl-4 col-lg-6 col-md-6 grid-item case4">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/web-design/web-design-3-2.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case4">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/web-design/web-design-Group-115.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case4">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/web-design/web-design-Group-118.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case4">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/web-design/web-design-Group-119.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case4">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/web-design/web-design-Group-121.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case4">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/web-design/web-design-Mask-group-2.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case4">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/web-design/wp-5-720x720-1.png" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Website</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>